import { Employee } from "../interfaces/User";
import { useAppSelector } from "../store/hooks";
import { ServiceProvider } from "../interfaces/ServiceProvidersInterface";

const useCurrentAuthenticable = (): {
  authenticable: "employee" | "serviceProvider";
  employee?: Employee;
  serviceProvider?: ServiceProvider;
} => {
  const authenticableData = useAppSelector((state) => state.userContext?.user);
  const authenticable = useAppSelector((state) => state.userContext?.userCreds.authenticable);

  return {
    authenticable,
    employee: authenticable === "employee" ? (authenticableData as Employee) : undefined,
    serviceProvider:
      authenticable === "serviceProvider" ? (authenticableData as ServiceProvider) : undefined
  };
};

export default useCurrentAuthenticable;
